import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const APIBaseURL = import.meta.env.VITE_DASHBOARD_API_ENDPOINT;

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${APIBaseURL}/api/reports`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as ReduxStoreState).auth.token;
      if (token) {
        headers.set('Authorization', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSummaryStatus: builder.query<SummaryReportResponse, GetSummaryParams>({
      query: (params) => ({
        url: '/summary',
        params: {
          ...params,
          appFilters: JSON.stringify(params.appFilters),
        },
      }),
    }),
  }),
});

export const { useLazyGetSummaryStatusQuery } = reportsApi;
